import React from 'react';

const Success = ({label_url}) => (
    <div className="rounded-md bg-green-50 p-4">
      <div className="flex">
        <div className="flex-shrink-0">
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-green-800">Item successfully verified</h3>
          <div className="mt-2 text-sm text-green-700">
              <p>Please use this shipping label: <a href={label_url}> {label_url} </a></p>
          </div>
          <div className="mt-4">
            <div className="-mx-2 -my-1.5 flex">
            </div>
          </div>
        </div>
      </div>
    </div>
);

export default Success;
